import { render, staticRenderFns } from "./ReserveForm.vue?vue&type=template&id=979fa44e&"
import script from "./ReserveForm.vue?vue&type=script&lang=js&"
export * from "./ReserveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports